<script>
	export let name;
	export let icon;
    export let description;
</script>
<div class="restaurant_box">
	<div class="vc_column-inner">
		<div class="d-flex mobile-fc">
			<div class="vc_empty_space restaurant_menu d-flex justify-content-center" style="height: 510px">
				<img src="/images/{icon}" alt="" />
			</div>
			<div class="w-70">
				<div class="restaurant_right">
					<div class="vc_column-inner ">
						<div class="" style="padding-top: 5% !important;">
							<div class="vc_separator wpb_content_element vc_separator_align_center vc_sep_width_100 vc_sep_border_width_2 vc_sep_pos_align_center vc_separator-has-text">
								<span class="vc_sep_holder vc_sep_holder_l">
									<span style="border-color:#0f2453;" class="vc_sep_line"></span>
								</span>
								<h4>{name}</h4>
								<span class="vc_sep_holder vc_sep_holder_r">
									<span style="border-color:#0f2453;" class="vc_sep_line"></span>
								</span>
							</div>
                            <div class="">
                                <p>
                                    {@html description}
                                </p>
                            </div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</div>


<style>

	.vc_separator.vc_separator_align_center h4 {
		padding: 0 0.8em;
	}
	
	.vc_separator h4 {
		line-height: 1em;
		font-size: 100%;
		margin: 0;
		word-wrap: break-word;
		-webkit-box-flex: 0;
		-webkit-flex: 0 1 auto;
		-ms-flex: 0 1 auto;
		flex: 0 1 auto;
	}

	.vc_separator.vc_sep_border_width_2 .vc_sep_holder .vc_sep_line {
		border-top-width: 2px;
	}

	.vc_separator .vc_sep_holder .vc_sep_line {
		height: 1px;
		border-top: 1px solid #EBEBEB;
		display: block;
		position: relative;
		top: 1px;
		width: 100%;
	}

	.vc_empty_space {
		width: 60%;
		border-radius: 25px;
		overflow: hidden;
	}

	.restaurant_box {
		-moz-border-bottom-colors: none;
		-moz-border-left-colors: none;
		-moz-border-right-colors: none;
		-moz-border-top-colors: none;
		background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
		border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4) rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
		border-image: none;
		border-radius: 25px;
		box-shadow: 8px 8px 8px #888888;
		margin-bottom: 25px;
		margin-top: 25px;
	}

	.restaurant_right {
		padding-left: 50px;
		padding-top: 50px;
		padding-right: 25px;
	}

	.vc_sep_holder_l, .vc_sep_holder_r {
		height: 1px;
		position: relative;
		-webkit-box-flex: 1;
		-webkit-flex: 1 1 auto;
		-ms-flex: 1 1 auto;
		flex: 1 1 auto;
		min-width: 10%;
	}

	.vc_separator {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	h4 {
	
	}

	.w-70 {
		width: 70%;
	}

    p {
        color: #444444;
        font-size: 1.125rem;
        line-height: 2rem;
    }

	@media only screen and (min-width: 320px) and (max-width: 600px) {
		.mobile-fc {
			flex-flow: column;
		}

		.vc_empty_space {
			width: 100%;
			border-radius: 25px 25px 0 0;
			height: auto !important;
		}

		.w-70 {
			width: 100%;
		}

		.restaurant_right {
			padding-left: 20px;
			padding-top: 24px;
			padding-right: 20px;
		}
	}

</style>